export default {"src":"/_next/static/media/resortpass-white-logo.bd73cf7a.svg","height":28,"width":280,"blurWidth":0,"blurHeight":0};